export const getCurrentFileId = (state) => state.current.fileId;

export const getCurrentFilerrId = (state) => state.current.filerrId;

export const getCurrentUserId = (state) => state.current.userId;

export const getCurrentGroupId = (state) => state.current.groupId;

export const getCurrentCollaboratorId = (state) => state.current.collaboratorId;

export const getCurrentCommentId = (state) => state.current.commentId;

export const getCurrentTimecode = (state) => state.current.timecode || 0;

export const getCurrentReviewId = (state) => state.current.reviewId;
